import storage from "./storage";
import client from "./client";
import {debounce} from "lodash";

const MAX_MESSAGE_DELAY = 20000 // 20s - inactive time between message before sending

class Metric {
    constructor(storage,client) {
        this.storage = storage
        this.client = client

        // Debouncing sendMessage to avoid sending messages too frequently
        this.sendMessages = debounce(this._sendMessages.bind(this), MAX_MESSAGE_DELAY)
    }

    init() {
        // We can try to avoid having the browser closed before sending the messages
        // if we detect the cursor trying to exit the page we can send the messages immediately
        this.detectExitIntention(this._sendMessages.bind(this))
        // If we have old messages ( maybe the browser was closed before sending the messages )
        // We will send them first
        this._sendMessages()
    }


    detectExitIntention(action) {
        document.addEventListener('mouseout', (e) => {
            if (!e.toElement && !e.relatedTarget) {
                action()
            }
        })
    }

    log(message) {
        this.storage.add(message)
        this.sendMessages()
    }

    async _sendMessages() {
        let messages = this.storage.get()
        if (messages.length === 0) return
        try {
            this.client.send(messages)
            this.storage.sent(messages)
        }
        catch (e) {
            this.storage.failed(messages)
        }
    }
}

export default new Metric(storage,client)